import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../../store/reducers/preferences';
import {useSettingsStyles} from '../userProperties';
import {useTranslation} from 'react-i18next';
import {FormControlLabel, FormLabel, RadioGroup} from '@mui/material';
import config from '../../../../app/config';
import Radio from '@mui/material/Radio';
import {isMobile} from 'react-device-detect';
import {isNull} from 'lodash';

const DEFAULT_STATE = {
    switchMapMode: 'auto',
};

const SwitchMapMode = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(!isNull(agylePreference?.switchMapMode) ? agylePreference?.switchMapMode : DEFAULT_STATE.switchMapMode);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.switchMapMode);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (_e, val) => {
        setMode(val);
        props.onChange('switchMapMode', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default behaviour of switching map')}
            </FormLabel>

            <RadioGroup
                value={mode}
                row
                onChange={handleChange}
            >
                <FormControlLabel
                    disabled={isMobile}
                    value="auto"
                    control={<Radio/>}
                    label={t('Auto')}
                />

                {config?.modules?.map?.customMapConfig?.map(map =>
                    <FormControlLabel
                        key={map.hospitalId}
                        value={map.mapPath}
                        control={<Radio/>}
                        label={map.name}
                    />,
                )}

                <FormControlLabel
                    value="central"
                    control={<Radio/>}
                    label={t('Central Page')}
                />
            </RadioGroup>
        </div>
    );
});

export default SwitchMapMode;
